import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-list.css';
import UitkListContext from './uitk-list.esm.js';
import { UitkListOrientations, UitkListSizes, UitkListItemThemes, UitkListBullets } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkListItem = function (props) {
    var children = props.children, _a = props.theme, theme = _a === void 0 ? 'default' : _a, attributes = __rest(props, ["children", "theme"]);
    var context = React.useContext(UitkListContext);
    var bullet = context.bullet, orientation = context.orientation, size = context.size, type = context.type, indent = context.indent;
    var bulletClass = function () {
        // If bullet is default, set type as bullet style
        // if bullet is not default, set bullet as bullet style
        var value;
        if (bullet && type) {
            value = UitkListBullets.get(bullet) === 'bullet-default' ? "bullet-".concat(type) : UitkListBullets.get(bullet);
        }
        return value;
    };
    var baseClass = 'uitk-typelist-item'; // Temporary: name clash with menu
    var bulletBaseClass = "".concat(baseClass, "-bulletchar");
    var wrapperClassNames = getClassNameList(baseClass, "".concat(baseClass, "-").concat(bulletClass()), bullet && bullet.includes('icon') && "".concat(baseClass, "-bullet-icon"), orientation && "".concat(baseClass, "-").concat(UitkListOrientations.get(orientation)), size && "".concat(baseClass, "-").concat(UitkListSizes.get(size)), bullet && !bullet.includes('icon') && "".concat(baseClass, "-").concat(UitkListItemThemes.get(theme)), bullet && bullet.includes('icon') && theme && "".concat(baseClass, "-bullet-icon-").concat(UitkListItemThemes.get(theme)), indent ? "".concat(baseClass, "-indent") : "".concat(baseClass, "-no-indent"));
    var bulletCssClassNames = getClassNameList(bulletBaseClass, "".concat(bulletBaseClass, "-").concat(bulletClass()), size && "".concat(bulletBaseClass, "-").concat(UitkListSizes.get(size)));
    var displayChildren = React.Children.toArray(children).map(function (child) {
        var _a;
        return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'UitkIcon' ? (React.createElement("div", { className: getClassNameList("".concat(baseClass, "-icon")) }, child)) : (child);
    });
    // Set bullet markup?
    var bulletMarkup = bullet &&
        (UitkListBullets.get(bullet) === 'bullet-default' || UitkListBullets.get(bullet) === 'bullet-tiered-numbered') ? (React.createElement("span", { "aria-hidden": "true", className: bulletCssClassNames })) : null;
    // Wrap children to make grid layout to work as expected with bullet markup
    var wrappedChildren = bulletMarkup ? (React.createElement("span", { className: getClassNameList("".concat(baseClass, "-child")) }, displayChildren)) : (displayChildren);
    return displayChildren ? (
    // Disabling the following rule. The role was added in #2287
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    React.createElement("li", __assign({ className: wrapperClassNames }, attributes, { role: "listitem" }),
        bulletMarkup,
        wrappedChildren)) : null;
};
UitkListItem.displayName = 'UitkListItem';

export { UitkListItem };
